import Vue from 'vue'
import Router from 'vue-router'
import errosRoutes from '@/modules/erros/routes'
import usuariosRoutes from '@/modules/usuarios/routes'
import externalBiRoutes from '@/modules/external-bi/routes'
import redirects from './redirects'

Vue.use(Router)

export default new Router({
  routes: [...usuariosRoutes, ...errosRoutes, ...externalBiRoutes, ...redirects],
})
